import AcUnitIcon from '@mui/icons-material/AcUnit'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'
import { Box, Grid } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Title from '../../SpiderWebSite/components/Title'
import { IReduxState } from '../../store'
import { IEnseignantItem, addArrayGagnantToPrint, setArrayGagnantToPrint, setChoising, setdataFiltered } from '../../store/focusEcoleSlice'
import { getMonthNumberFromDate } from '../../util/functions'
import DialogUrne from './DialogUrne'
// import { PrintEtat } from './Etat/print'
import Liste from './Liste'
import SearchBarByEtab from './SearchBarByEtab'
import SearchMonth from './SearchMonth'
import SearchYear from './SearchYear'
import Statistique from './Statistique'
import Urne from './Urne'

export interface IOptionChoisie {
    optionChoisie: string;
}

export default function Enseignant() {


    const dispatch = useDispatch();
    const { enseignants, currentEtab, choising, arrayGagnantToPrint } = useSelector((state: IReduxState) => state.focusEcole);
    console.log("🚀 ~ Enseignant ~ arrayGagnantToPrint:", arrayGagnantToPrint)
    console.log("🚀 ~ Enseignant ~ enseignants:", enseignants)


    const [search, setSearch] = React.useState("");
    const [localDatasFiltered, setLocalDatasFiltered] = useState<IEnseignantItem[]>([])
    const [currentYear, setCurrentYear] = useState<any>({})
    const [currentMonth, setCurrentMonth] = useState<any>({})
    const [openUrne, setOpenUrne] = useState(false)
    const [isTurned, setTurned] = useState(false);
    const [winner, setWinner] = useState<IEnseignantItem | undefined>()


    const handleUrneClose = () => {
        setOpenUrne(false);
        setWinner(undefined)
        dispatch(addArrayGagnantToPrint([]));
    };

    const handleUrneOpen = () => {
        setOpenUrne(true);
    };

    /**
     * Filtrer la liste en fonction du status (payé, non payé) puis par etablissement.
     */
    useEffect(() => {
        const { codeEtab } = currentEtab;
        const { anneeScolaire } = currentYear;
        const { numero } = currentMonth;

        //obtenir tous les enseignant d'un établissement par le codeEtab.
        const enseignantByCodeEtab =
            codeEtab === undefined
                ? [...enseignants]
                : enseignants.filter((item: IEnseignantItem) => item.codeEtab === codeEtab);

        //obtenir tous les enseignant d'un établissement pour une année donnée.
        const enseignantByYear =
            anneeScolaire === undefined
                ? [...enseignantByCodeEtab]
                : enseignantByCodeEtab.filter((item: IEnseignantItem) => item.anneeScolaire === anneeScolaire);

        //obtenir tous les enseignant d'un établissement pour une année donnée avec un mois spécifique.
        const enseignantByMonth =
            numero === undefined
                ? [...enseignantByYear]
                : enseignantByYear.filter((item: IEnseignantItem) => getMonthNumberFromDate(new Date(item.date)) === numero);


        //obtenir une occurence dans la liste lorqu'on tape dans le champ de saisi
        const enseignantByMotCle =
            search.length === 0
                ? [...enseignantByMonth]
                : enseignantByMonth.filter((item: IEnseignantItem) => {
                    const value: any = `${item.libelleMatiereLong} ${item.nomPersonnel} ${item.prenomPersonnel} ${item.libelleEtab} ${item.codeEtab}`;
                    return value.toLowerCase().includes(search.toLowerCase());
                });

        dispatch(setdataFiltered(enseignantByMotCle))
        setLocalDatasFiltered(enseignantByMotCle)
    }, [currentYear, currentMonth, currentEtab, search]);


    const choisirEnseignantAuHasard = async () => {
        dispatch(setChoising(true));
        setWinner(undefined)
        const choixAleatoire = new Promise((resolve) => {
            // Simuler une attente avec setTimeout pour imiter une opération asynchrone
            setTimeout(() => {
                //Changer l'ordre des objets
                const nouvelOrdre = trierParIdPersonnel();
                // Générer un index aléatoire dans le tableau des enseignants
                const indexAleatoire = Math.floor(Math.random() * nouvelOrdre.length);
                // Récupérer l'enseignant à l'index aléatoire
                const enseignantChoisi = nouvelOrdre[indexAleatoire];
                resolve(enseignantChoisi);
            }, 5000); // Temps d'attente simulé de 5 seconde
        });
        choixAleatoire.then((enseignantChoisi: any) => {
            dispatch(addArrayGagnantToPrint(enseignantChoisi));
            setWinner(enseignantChoisi)
            dispatch(setChoising(false));
        });
    };

    const rafraichirListe = () => {
        setLocalDatasFiltered(enseignants)
        dispatch(setArrayGagnantToPrint([]));
    }


    const etatFilter = () => {
        if (Object.keys(currentEtab).length
            || Object.keys(currentYear).length
            || Object.keys(currentMonth).length
            || arrayGagnantToPrint.length
        ) return true
    }

    //Change l'ordre des éléments dans le tableau d'objets
    const trierParIdPersonnel = () => {
        let newArray = [...localDatasFiltered]
        return newArray?.sort((a, b) => {
            const indexAleatoire = Math.floor(Math.random() * newArray.length);
            const enseignantTrouveAuHazard = newArray[indexAleatoire];
            // Si a et b ont la propriété 'idPersonnel', triez par 'idPersonnel'
            if ('idPersonnel' in a && 'idPersonnel' in b) {
                return a.idPersonnel - enseignantTrouveAuHazard.idPersonnel;
            }
            // Si les types ne correspondent pas ou s'ils n'ont pas la propriété 'idPersonnel', ne modifiez pas l'ordre
            return 0;
        });
    }


    return (
        <Box>
            <Grid container spacing={2} style={{ background: "#F7F7F7" }}>
                <Grid item xs={12} md={12} sm={12} lg={12}><Title intitule='Liste des utilisateurs de Prof - Expert' /></Grid>
                <Grid item xs={12} md={3} sm={3} lg={3}>
                    <SearchBarByEtab
                        localDatasFiltered={localDatasFiltered}
                        setLocalDatasFiltered={setLocalDatasFiltered}
                    />
                </Grid>
                <Grid item xs={12} md={2} sm={2} lg={2}>
                    <SearchYear
                        localDatasFiltered={localDatasFiltered}
                        setLocalDatasFiltered={setLocalDatasFiltered}
                        currentYear={currentYear}
                        setCurrentYear={setCurrentYear}
                    />
                </Grid>

                <Grid item xs={12} md={2} sm={2} lg={2}>
                    <SearchMonth
                        localDatasFiltered={localDatasFiltered}
                        setLocalDatasFiltered={setLocalDatasFiltered}
                        currentMonth={currentMonth}
                        setCurrentMonth={setCurrentMonth}
                    />
                </Grid>

                <Grid item xs={12} md={1} sm={1} lg={1}>
                    {/* <IconButton
                        aria-label="delete"
                        color='primary'
                        onClick={handleUrneOpen}
                    >
                        <MeetingRoomIcon />
                    </IconButton> */}

                    <IconButton
                        aria-label="delete"
                        color={etatFilter() ? 'primary' : 'default'}
                        onClick={rafraichirListe}
                    >
                        <FilterAltOffIcon />
                    </IconButton>


                    {/* <SearchBar
                        search={search}
                        setSearch={setSearch}
                    /> */}
                </Grid>
                <Grid item xs={12} md={3} sm={3} lg={3}>
                    <Statistique
                        localDatasFiltered={localDatasFiltered}
                    />
                </Grid>



                {/* <Grid item xs={12} md={1} sm={1} lg={1}>
                    <PrintEtat />
                </Grid> */}
            </Grid>

            <DialogUrne
                title="Tirage au sort"
                dialogContent={<Urne
                    winner={winner}
                />}
                actionLabel="Effectuer le tirage"
                open={openUrne}
                handleClose={handleUrneClose}
                actionFunction={choisirEnseignantAuHasard}
                addLoading={choising}
                iconeSauveButton={<AcUnitIcon />}
            />

            {<Liste
                localDatasFiltered={localDatasFiltered}
            />
            }
        </Box>
    )
}
